import type { PortalHistoryEntry } from '../api/types';

/** Resolves the backend sentenceKey (history.*) with entry params (§10.2 H3). */
export function historySentence(
  e: Pick<PortalHistoryEntry, 'sentenceKey' | 'params'>,
  t: (key: string, opts?: Record<string, unknown>) => string,
): string {
  const key =
    e.sentenceKey === 'history.collected' && e.params.boxes === 0
      ? 'history.collectedSticks'
      : e.sentenceKey;
  const translated = t(key, {
    boxes: e.params.boxes,
    sticks: e.params.sticks,
    shopName: e.params.shopName ?? '',
    brands: e.params.brandNames?.join(', ') ?? '',
  });
  return translated === key ? t('history.adjustment', { sticks: e.params.sticks }) : translated;
}
